(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var button = root.querySelector('[data-outfit-add]');
    var status = root.querySelector('[data-outfit-status]');
    var summary = root.querySelector('[data-outfit-summary]');
    var money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'});
    function items() {
      return Array.from(root.querySelectorAll('[data-outfit-item]')).filter(function(card){return card.querySelector('[data-outfit-check]').checked;}).map(function(card){var option=card.querySelector('[data-outfit-variant]').selectedOptions[0];return {id:Number(option.value),quantity:1,price:Number(option.dataset.price)};});
    }
    function update() {
      var selected=items(),total=selected.reduce(function(sum,item){return sum+item.price;},0);
      var rate=selected.length>=3?0.85:selected.length>=2?0.9:1;
      summary.hidden=false;
      root.querySelector('[data-outfit-total]').textContent=money.format(total/100);
      root.querySelector('[data-outfit-estimate]').textContent=money.format(Math.round(total*rate)/100);
      button.disabled=selected.length===0;
      status.textContent=selected.length?'':root.dataset.empty;
    }
    root.addEventListener('change',update);
    button.addEventListener('click',async function(){
      var selected=items();if(!selected.length)return;
      var label=button.textContent;button.disabled=true;button.textContent=root.dataset.loading;status.textContent='';
      try {
        var base=(window.Shopify && Shopify.routes && Shopify.routes.root)||'/';
        var response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected.map(function(item){return {id:item.id,quantity:1};})})});
        var result=await response.json();if(!response.ok)throw new Error(result.description||root.dataset.error);
        window.location.assign(base+'cart');
      }catch(error){status.textContent=error.message||root.dataset.error;button.disabled=false;button.textContent=label;}
    });
    update();
  }
  document.querySelectorAll('[data-outfit-builder]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-outfit-builder]').forEach(init);});
})();
